import * as axiosService from "../axiosService";


export const CheckTruckExist = (payload) => {
    const queryParams = [];
    if (payload.assetPlateNumber) {
        queryParams.push(`assetPlateNumber=${payload.assetPlateNumber}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Truck/IsTruckExist${queryString}`);
};


export const addTruckInFleet = (payload) => {
    
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/AddTruckInFleet`, payload);
};

//saveTruck
export const addTruckOnboard = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Truck/SaveTruckInfo`, payload);
};

// Quick onboarding of a truck (multipart FormData with documents in "files")
export const saveTruckInfoQuick = (formData) => {
    return axiosService.PostFileAuth(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Truck/SaveTruckInfoQuick`, formData, {});
};


export const getTruckById = (truckId) => {

    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Truck/GetTruck?truckId=${truckId}`);
};


export const getAlltruck = (payload) => {
    const queryParams = [];

    if (payload.searchText) {
        queryParams.push(`searchText=${payload.searchText}`);
    }
    if (payload.pageNumber) {
        queryParams.push(`pageNumber=${payload.pageNumber}`);
    }
    if (payload.pageSize) {
        queryParams.push(`pageSize=${payload.pageSize}`);
    }
    if (payload.status) {
        queryParams.push(`status=${payload.status}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }
    
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/GetFleetTruckList${queryString}`);
};


export const getTruckDetails = (truckId,supplierId) => {
    const queryParams = [];

    if (truckId) {
        queryParams.push(`externalTruckId=${truckId}`);
    }
    if (supplierId) {
        queryParams.push(`supplierId=${supplierId}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/GetFleetTruckDetail${queryString}`);

};


export const RemoveTruckFromFleet = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/RemoveTruckFromFleet`, payload);
};


export const getTripDetails = (payload) => {
    
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/GetTripList `, payload);
};



